var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	27308: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/keycodes", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_keycodes_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 28456))))))),
	41493: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_common_fesm2020_common_mjs-_ec491").then(() => (() => (__webpack_require__(/*! @angular/common */ 94666))))))),
	46269: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_core_fesm2020_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 22560))))))),
	58829: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/layout", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_layout_mjs-_516e1").then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 83278))))))),
	62348: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/observers", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_observers_mjs-_9dd21").then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 43773))))))),
	75210: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/coercion", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_coercion_mjs-_e7881").then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 48971))))))),
	92597: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/platform", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_platform_mjs-_eeec1").then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 89107))))))),
	62597: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/collections", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_collections_mjs-_15111").then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 11755))))))),
	13916: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/a11y", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_a11y_mjs-_b54c1").then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 24218))))))),
	10851: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/overlay", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_overlay_mjs-_4b201").then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 25895))))))),
	565: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/portal", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_portal_mjs-_32ad0").then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 17520))))))),
	4968: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/bidi", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_bidi_mjs-_66fb1").then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 72867))))))),
	4051: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/scrolling", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_scrolling_mjs-_93761").then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 76328))))))),
	92497: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common/http", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_common_fesm2020_http_mjs-_68761").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 58987)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"node_modules_angular_cdk_fesm2020_a11y_mjs-_b54c0": [
		27308,
		41493,
		46269,
		58829,
		62348,
		75210,
		92597
	],
	"node_modules_angular_cdk_fesm2020_accordion_mjs-_cc711": [
		46269,
		62597,
		75210
	],
	"node_modules_angular_cdk_fesm2020_bidi_mjs-_66fb0": [
		41493,
		46269
	],
	"node_modules_angular_cdk_fesm2020_clipboard_mjs-_3a891": [
		41493,
		46269
	],
	"node_modules_angular_cdk_fesm2020_coercion_mjs-_e7880": [
		46269
	],
	"node_modules_angular_cdk_fesm2020_collections_mjs-_15110": [
		46269
	],
	"node_modules_angular_cdk_fesm2020_dialog_mjs-_b1e01": [
		13916,
		10851,
		92597,
		565,
		41493,
		46269,
		27308,
		4968
	],
	"node_modules_angular_cdk_fesm2020_drag-drop_mjs-_11e31": [
		46269,
		41493,
		4051,
		92597,
		75210,
		13916,
		4968
	],
	"node_modules_angular_cdk_fesm2020_layout_mjs-_516e0": [
		46269,
		75210,
		92597
	],
	"node_modules_angular_cdk_fesm2020_observers_mjs-_9dd20": [
		46269,
		75210
	],
	"node_modules_angular_cdk_fesm2020_overlay_mjs-_4b200": [
		565,
		4051,
		4968,
		27308,
		41493,
		46269,
		75210,
		92597
	],
	"node_modules_angular_cdk_fesm2020_platform_mjs-_eeec0": [
		41493,
		46269
	],
	"node_modules_angular_cdk_fesm2020_portal_mjs-_32ad1": [
		41493,
		46269
	],
	"node_modules_angular_cdk_fesm2020_scrolling_mjs-_93760": [
		4968,
		41493,
		46269,
		62597,
		75210,
		92597
	],
	"node_modules_angular_cdk_fesm2020_stepper_mjs-_253b1": [
		13916,
		4968,
		75210,
		27308,
		46269,
		92597
	],
	"node_modules_angular_cdk_fesm2020_table_mjs-_f6c21": [
		4968,
		75210,
		62597,
		92597,
		4051,
		41493,
		46269
	],
	"node_modules_angular_cdk_fesm2020_text-field_mjs-_d10b1": [
		92597,
		46269,
		75210,
		41493
	],
	"node_modules_angular_cdk_fesm2020_cdk_mjs-_1e771": [
		46269
	],
	"node_modules_angular_common_fesm2020_http_mjs-_68760": [
		41493,
		46269
	],
	"node_modules_angular_common_fesm2020_common_mjs-_ec490": [
		46269
	],
	"node_modules_angular_router_fesm2020_router_mjs-_6f001": [
		46269,
		41493
	],
	"node_modules_xpo-ltl_config-manager_fesm2020_xpo-ltl-config-manager_mjs-_2a0e1": [
		46269
	],
	"node_modules_xpo-ltl_ngx-ops-state_fesm2020_xpo-ltl-ngx-ops-state_mjs-_166b1": [
		46269
	],
	"node_modules_angular-oauth2-oidc_fesm2022_angular-oauth2-oidc_mjs-_08791": [
		46269,
		41493,
		92497
	],
	"node_modules_angular_cdk_fesm2020_platform_mjs-_eeec1": [
		41493
	],
	"node_modules_angular_cdk_fesm2020_overlay_mjs-_4b201": [
		4051,
		75210
	],
	"node_modules_angular_cdk_fesm2020_a11y_mjs-_b54c1": [
		27308,
		41493,
		58829,
		62348,
		75210
	],
	"node_modules_angular_cdk_fesm2020_bidi_mjs-_66fb1": [
		41493
	],
	"node_modules_angular_cdk_fesm2020_scrolling_mjs-_93761": [
		62597
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}